import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllBaixaManualEstoque } from '../service';
import {
  LIST_BAIXAR_MANUAL_ESTOQUE,
  LIST_BAIXAR_MANUAL_ESTOQUE_PENDING,
  LIST_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
  LIST_BAIXAR_MANUAL_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaListAllBaixaManualEstoque(action) {
  yield put({ type: LIST_BAIXAR_MANUAL_ESTOQUE_PENDING })

  try {
    const list = yield call(findAllBaixaManualEstoque)
    
    yield put({ type: LIST_BAIXAR_MANUAL_ESTOQUE_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_BAIXAR_MANUAL_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllBaixaManualEstoque() {
  yield takeLatest(LIST_BAIXAR_MANUAL_ESTOQUE, sagaListAllBaixaManualEstoque)
}